// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCancelPolicy_root__3XdgA","container":"ModalCancelPolicy_container__32lFM","text":"ModalCancelPolicy_text__1aVpk"};